
import { createApi } from '@stilingue/st-auth-utils';
import Service from '@/services/Service';
import { error401Handler } from '@/utils/error';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = response => response.data;

export class BlipService extends Service {
  constructor(gateway) {
    const api = createApi('/blip-service/', gateway, { error401Handler });
    super(api, { afterParser });
  }

  getReceivedMessages(params = {}) {
    return this.find({
      url: 'received-messages',
      ...params,
      crossDomain: true,
    });
  }

  getSentMessages(params = {}) {
    return this.find({
      url: 'sent-messages',
      ...params,
      crossDomain: true,
    });
  }

  getActiveMessages(params = {}) {
    return this.find({
      url: 'active-messages',
      ...params,
      crossDomain: true,
    });
  }

  getActiveIdentity(params = {}) {
    return this.find({
      url: 'active-identity',
      ...params,
      crossDomain: true,
    });
  }

  getEngagedIdentity(params = {}) {
    return this.find({
      url: 'engaged-identity',
      ...params,
      crossDomain: true,
    });
  }

  getEngagedUsers(params = {}) {
    return this.find({
      url: 'engaged-identity',
      ...params,
      crossDomain: true,
    });
  }

  getActiveMessagesPerDomain(params = {}) {
    return this.find({
      url: 'active-messages-per-domain',
      ...params,
      crossDomain: true,
    });
  }

  async getReceivedAndSentMessages(params = {}) {
    try {
      const receivedAndSentResponse = await Promise.all([
        this.getReceivedMessages(params),
        this.getSentMessages(params),
      ]);

      return receivedAndSentResponse;
    } catch (error) {
      console.error(error);
    }
  }

  getMetricsContacts(params = {}) {
    return this.find({
      url: 'contacts',
      ...params,
      crossDomain: true,
    });
  }

  getEventTrack(params = {}) {
    return this.find({
      url: 'event-track',
      ...params,
      crossDomain: true,
    });
  }

  getEventTrackCount(params = {}) {
    return this.find({
      url: 'event-track-count',
      ...params,
      crossDomain: true,
    });
  }
}

export default new BlipService(gateway);
